import axios from 'axios'
import qs from 'qs'

// 数据统计-收益
export const gameDetail = () => {
    return axios({
        url: '/index/income' ,
        method: 'get'
    })
  }